export default function MayorDetails() {
  return (
    <div>
      <div className="government-bg bg-image">
        <div className="gap-spacer"></div>
        <div className="page-title top-cap-outlines">
          <h2>Mayor's Office</h2>
        </div>

        {/*End Large Image Space*/}

        {/*Start Main Content*/}
        <div className="content-fluid">
          <div className="mb-960-center-container mid-side-outlines">
            {/*Full Width Element*/}
            <div className="mb-960-col-50p">
              <div className="left-right-padding-1em">
                <h4>Mayor of Morrisville Borough</h4>
                <ul>
                  <li>Elected official</li>
                  <li>4 year term</li>
                  <li>Term expires first Monday in January</li>
                </ul>
              </div>
            </div>
            <div className="mb-960-col-50p">
              <div className="council-members">
                <h4>Current Mayor: Gary Wallace</h4>
                <p>
                  Term Expires: January 2030
                  <br />
                  <a href="mailto:GWallace@morrisvilleboro.org">
                    <i className="fa-solid fa-envelope"></i>
                    &nbsp;GWallace@morrisvilleboro.org
                  </a>
                  <br />
                  <a href="tel:2672410985">
                    <i className="fa-solid fa-phone"></i>&nbsp;267-241-0985
                  </a>
                  <br />
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="page-footer bottom-cap-outlines">&nbsp;</div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
      </div>
    </div>
  );
}
